type ProfileMenuContainerProps = {
	visible?: boolean;
	onClickUrl?: () => void;
	children?: React.ReactChild | React.ReactChild[];
	right?: number;
	top?: number;
};
const ProfileMenuContainer: React.FC<ProfileMenuContainerProps> = ({ visible, children, right, top }) => {
	return (
		<div
			onClick={e => {
				e.preventDefault();
				e.stopPropagation();
			}}
			style={{ right: `${right ? right : 0}px`, top: `${top ? top : 0}px` }}
			className={`${
				visible ? 'profile-menu-container profile-menu-show' : 'profile-menu-container profile-menu-hide'
			} `}
		>
			<div className="absolute profile-menu">
				<div className="profile-menu-content d-flex f-column">{children}</div>
			</div>
			<div className="absolute profile-menu2"></div>
		</div>
	);
};

export default ProfileMenuContainer;
